import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // Não insiste em erros de autorização/validação; insiste em falhas de rede.
      retry: (count, err) => !(err instanceof ApiError && err.status >= 400 && err.status < 500) && count < 2,
    },
  },
});

export const qk = {
  session: ['session'] as const,
  members: ['members'] as const,
  invitations: ['invitations'] as const,
  organization: ['organization'] as const,
  signupStatus: ['signup-status'] as const,
};
